import React from "react";
import { Card, CardBody } from "reactstrap";
import $ from "jquery";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";

export const analyticsColumns = [
  {
    data: null,
    render: function (data: any, type: any, row: any) {
      const joinArray = [row.mobile, row.email].filter(Boolean);

      return `<div style="cursor: pointer; width: 350px"> 
                           <div style="color: black; fontweight: bold;">${
                             row.firstname
                           } ${row.lastname}</div>
                           <div>${joinArray.join(" | ")}</div>
                         </div>`;
    },
    createdCell: function (cell: any, cellData: any, rowData: any) {
      $(cell).addClass("column-click");
    },
    title: "Premise",
  },
  {
    data: null,
    createdCell: function (cell: any, cellData: any, rowData: any) {
      $(cell).addClass("column-click");
    },
    title: "No. Of Device",
    render: function (data: any, type: any, row: any) {
      return `<div class="text-success fw-bold" style="cursor: pointer;">${
        row?.noOfChips ? `${row?.noOfChips}` : "-"
      }</div>`;
    },
  },
  {
    data: null,
    createdCell: function (cell: any, cellData: any, rowData: any) {
      $(cell).addClass("column-click");
    },
    title: "No. of Offline",
    render: function (data: any, type: any, row: any) {
      return `<div class="text-danger fw-bold" style="cursor: pointer;">${
        row?.noOfChipsOffline ? `${row?.noOfChipsOffline}` : "-"
      }</div>`;
    },
  },
  {
    data: null,
    createdCell: function (cell: any, cellData: any, rowData: any) {
      $(cell).addClass("column-click");
    },
    title: "Type",
    render: function (data: any, type: any, row: any) {
      const statusBadge = row?.isOnline
        ? '<span class="font-size-11 badge-soft-success badge bg-secondary">Online</span>'
        : '<span class="font-size-11 badge-soft-danger badge bg-secondary">Offline</span>';

      return `<div style="cursor: pointer;">${statusBadge}</div>`;
    },
  },
  {
    data: null,
    title: "Parent User",
    render: function (data: any, type: any, row: any) {
      const list = row?.parentUserDetails || [];
      return list.length;
    },
  },
  {
    data: null,
    title: "Sub Users",
    render: function (data: any, type: any, row: any) {
      const list = row?.subUsersDetails || [];
      return list.length;
    },
  },
  {
    data: null,
    createdCell: function (cell: any, cellData: any, rowData: any) {
      $(cell).addClass("column-click");
    },
    title: "Status",
    render: function (data: any, type: any, row: any) {
      const statusBadge = row?.isActive
        ? '<span class="font-size-11 badge-soft-success badge bg-secondary">Active</span>'
        : `<span class="font-size-11 badge-soft-danger badge bg-secondary">Inactive</span>`;

      return `<div style="cursor: pointer;">${statusBadge}</div>`;
    },
  },
];

type AnalyticsUserTableProps = {
  hasApplied: boolean;
  loading: boolean;
  tableRef: React.RefObject<HTMLTableElement>;
};

const AnalyticsUserTable = ({
  hasApplied,
  loading,
  tableRef,
}: AnalyticsUserTableProps) => {
  if (!hasApplied) return null;

  return (
    <Card
      style={{
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30,
        marginBottom: 0,
        minHeight: 400,
      }}
    >
      <CardBody>
        <div>
          <div id="customLoader" style={{ display: "none" }}>
            <AirHomeLoader />
          </div>
          <div
            className="table-responsive"
            style={{ pointerEvents: loading ? "none" : "auto" }}
          >
            <table
              id={`dataTableUsers`}
              ref={tableRef}
              className="table table-hover"
              style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
            ></table>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default AnalyticsUserTable;
